import { render } from "./TaskTypeCreate.vue?vue&type=template&id=2e983aec&scoped=true"
import script from "./TaskTypeCreate.vue?vue&type=script&lang=js"
export * from "./TaskTypeCreate.vue?vue&type=script&lang=js"

import "./TaskTypeCreate.vue?vue&type=style&index=0&id=2e983aec&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e983aec"]])

export default __exports__